export default {
  orderTokenId: '',
  propertyId: '',
  status: 'CREATED',
  adults: 2,
  children: 0,
  pets: 0,
  type: 'booking',
  request: false,
  salesChannel: 'web',
  childrenFreeOfCharge: false,
  arrivalDate: '',
  departureDate: '',
  localizedArrivalDate: '',
  localizedDepartureDate: '',
  currencyCode: 'EUR',
  company: 'NOV',
  salesMarket: '999',
  language: 'en',
  referrer: '',
  agency: {
    agencyNumber: '',
    creditAgency: false,
    showSubId: false,
    message: '',
    subId: '',
    userId: '',
  },
  customer: {
    title: 'ms',
    email: '',
    abandonEmail: '',
    firstName: '',
    lastName: '',
    customerCountry: '',
    city: '',
    street: '',
    streetNumber: '',
    floor: '',
    additionalAddress: '',
    zipCode: '',
    phoneDialCode: '',
    additionalPhoneDialCode: '',
    phone: '',
    phoneNumber: '',
    phoneCode: '',
    additionalPhone: '',
  },
  information: {
    adultCount: 0,
    childrenCount: 3,
    extraBedCount: 2,
    allowedPetCount: 2,
    petsPrice: '',
    kidsFreeOfCharge: 2,
  },
  variableCosts: [],
  bookingPrice: {
    currencyCode: 'EUR',
    totalPrice: {
      amount: 0,
      currencyCode: 'EUR',
    },
    rentalPrice: {
      amount: 0,
      currencyCode: 'EUR',
    },
    paymentBeforeArrival: {
      amount: 0,
      currencyCode: 'EUR',
    },
    lineItems: [],
    rates: [],
  },
  services: [],
};
